module.exports = __webpack_public_path__ + "static/media/tiktok_logo.ebed2720.svg";